 import React from 'react'
// import { ReactDOM } from 'react-dom';
import { Icon } from '@iconify/react';
import "./stylesheet/social.css"

const icon=[{icon:<Icon icon="logos:twitter" width="40" height="40"/>
,link:"https://twitter.com/U_mangs"}
,//color="#9747ff"
{icon:<Icon icon="logos:linkedin-icon" color="#9747ff" width="40" height="40" />
,link:"https://www.linkedin.com/in/umangsahu/"}

,
{icon:<Icon icon="logos:whatsapp-icon" color="white" height="40" width='40' />
,link:"https://wa.me/9140560654?text=Hello%20"}

]

const Social = () => {

  return (
    <>
    <div className="icons">{
        icon.map((currelem,index)=>{
            return(
                <a href={currelem.link} target="_blank" key={10+index} >
               
        {currelem.icon}
        
            </a>
            )
    }
        )}
  </div> </> 
  )
}

export default Social